export const GETTER = {
  getAllUsers: "getAllUsers",
};

export const MUTAION = {
  setAllUsers: "setAllUsers",
  appendUser: "appendUser",
};
